/* ==========================================================================
   OTRAVIX — interactividad propia (vanilla JS, sin librerías)
   Cada componente comprueba si su elemento existe: el mismo archivo sirve
   para todas las páginas.
   ========================================================================== */
(function () {
  'use strict';

  var OX = (window.OX = window.OX || {});
  var cfg = (OX.config = Object.assign(
    {
      locale: 'es-ES',
      currency: 'EUR',
      // 'releasit' en la tienda; 'demo' en el prototipo HTML; 'cart' como respaldo
      buyMode: 'demo'
    },
    window.OX_CONFIG || {}
  ));

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Utilidades ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) {
    var value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency }).format(value);
    } catch (e) {
      return value.toFixed(2).replace('.', ',') + ' €';
    }
  }
  OX.money = money;

  /* ---------- Animaciones de entrada ---------- */
  function initReveal() {
    var items = $$('.ox-reveal:not(.is-visible)');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Menú móvil ---------- */
  function initDrawer() {
    var drawer = $('[data-ox-drawer]');
    if (!drawer || drawer.dataset.oxInit) return;
    drawer.dataset.oxInit = '1';
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var first = $('[data-ox-drawer-close]', drawer);
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    $$('[data-ox-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-ox-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    $$('a', drawer).forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    var track = $('[data-ox-gallery-track]', root);
    if (!track || root.dataset.oxInit) return;
    root.dataset.oxInit = '1';
    var slides = $$('.ox-gallery__slide', track);
    var dots = $$('[data-ox-gallery-dot]', root);
    var thumbs = $$('[data-ox-gallery-thumb]', root);
    var prev = $('[data-ox-gallery-prev]', root);
    var next = $('[data-ox-gallery-next]', root);
    var current = 0;

    function goTo(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    var counter = $('[data-ox-gallery-current]', root);
    function setActive(i) {
      current = i;
      if (counter) counter.textContent = String(i + 1);
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        if (n === i && t.parentElement) {
          var p = t.parentElement;
          var left = t.offsetLeft - p.offsetLeft - (p.clientWidth - t.clientWidth) / 2;
          p.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      });
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) setActive(Math.min(i, slides.length - 1));
        ticking = false;
      });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
    setActive(0);
  }

  /* ---------- Bloque de compra: packs, regalos, complementos y total ---------- */
  function initBuyBox() {
    var root = $('[data-ox-buy-root]');
    if (!root) return;

    var packInputs = function () { return $$('input[data-ox-pack]', root); };
    var addonInputs = function () { return $$('input[data-ox-addon]', root); };

    function selectedPack() {
      return packInputs().filter(function (i) { return i.checked; })[0] || packInputs()[0];
    }

    function state() {
      var p = selectedPack();
      var price = p ? Number(p.dataset.price) : Number(root.dataset.price || 0);
      var compare = p ? Number(p.dataset.compare || 0) : Number(root.dataset.compare || 0);
      var units = p ? Number(p.dataset.units || 1) : 1;
      var addons = addonInputs().filter(function (a) { return a.checked; });
      var addonsTotal = addons.reduce(function (s, a) { return s + Number(a.dataset.price || 0); }, 0);
      var total = price + addonsTotal;
      var compareTotal = (compare > price ? compare : price) + addonsTotal;
      return {
        pack: p,
        units: units,
        price: price,
        compare: compare,
        total: total,
        compareTotal: compareTotal,
        save: Math.max(0, compareTotal - total),
        addons: addons
      };
    }

    function setText(sel, text) { $$(sel).forEach(function (el) { el.textContent = text; }); }
    function setHidden(sel, hidden) { $$(sel).forEach(function (el) { el.hidden = hidden; }); }

    function render() {
      var s = state();
      setText('[data-ox-total]', money(s.total));
      setText('[data-ox-total-compare]', s.save > 0 ? money(s.compareTotal) : '');
      setText('[data-ox-total-save]', money(s.save));
      setHidden('[data-ox-total-save-row]', s.save <= 0);
      setText('[data-ox-cta-price]', money(s.total));
      setText('[data-ox-sticky-price]', money(s.total));
      if (s.pack) setText('[data-ox-pack-name]', s.pack.dataset.title || '');
      // Pack agotado: botones desactivados
      var soldOut = !!(s.pack && s.pack.disabled);
      $$('[data-ox-buy]').forEach(function (b) { b.disabled = soldOut; });

      // Regalos que se desbloquean según el número de unidades
      $$('[data-ox-gift]').forEach(function (g) {
        var min = Number(g.dataset.minUnits || 1);
        var unlocked = s.units >= min;
        var was = g.classList.contains('is-unlocked');
        g.classList.toggle('is-locked', !unlocked);
        g.classList.toggle('is-unlocked', unlocked);
        if (unlocked && !was) { g.classList.remove('is-unlocked'); void g.offsetWidth; g.classList.add('is-unlocked'); }
      });

      // Sincroniza el formulario de producto (lo que lee Releasit / el carrito)
      var form = $('[data-ox-product-form]');
      if (form && s.pack) {
        var idInput = $('input[name="id"]', form);
        var qtyInput = $('input[name="quantity"]', form);
        if (idInput && s.pack.dataset.variant) idInput.value = s.pack.dataset.variant;
        if (qtyInput) qtyInput.value = s.pack.dataset.qty || 1;
        if (idInput) idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Espejos (selector de packs repetido en el cierre)
      $$('[data-ox-packs-mirror] input[data-ox-mirror-of]').forEach(function (m) {
        m.checked = s.pack && m.dataset.oxMirrorOf === s.pack.id;
      });
      // Botones de "complementos recomendados"
      $$('[data-ox-reco]').forEach(function (b) {
        var input = document.getElementById(b.dataset.oxReco);
        var on = !!(input && input.checked);
        b.classList.toggle('is-added', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var label = $('[data-ox-reco-label]', b);
        if (label) label.textContent = on ? (b.dataset.labelOn || 'Añadido') : (b.dataset.labelOff || 'Añadir');
      });
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[data-ox-pack], input[data-ox-addon]')) render();
    });

    // Repite el selector de packs en la sección de cierre
    $$('[data-ox-packs-mirror]').forEach(function (holder) {
      var source = $('[data-ox-packs]', root);
      if (!source) return;
      var clone = source.cloneNode(true);
      clone.removeAttribute('data-ox-packs');
      $$('input[data-ox-pack]', clone).forEach(function (input) {
        var originalId = input.id;
        input.removeAttribute('data-ox-pack');
        input.setAttribute('data-ox-mirror-of', originalId);
        input.id = originalId + '-mirror';
        input.name = (input.name || 'ox-pack') + '-mirror';
        var label = input.closest('label');
        if (label) label.setAttribute('for', input.id);
        input.addEventListener('change', function () {
          var original = document.getElementById(originalId);
          if (original) { original.checked = true; render(); }
        });
      });
      holder.appendChild(clone);
    });

    // Complementos recomendados (sección "en la caja")
    $$('[data-ox-reco]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = document.getElementById(b.dataset.oxReco);
        if (!input) { if (b.dataset.href) window.location.href = b.dataset.href; return; }
        if (input.disabled) return;
        input.checked = !input.checked;
        render();
      });
    });

    // Todos los botones de compra
    $$('[data-ox-buy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        OX.buy(state(), btn);
      });
    });

    render();
  }

  /* ---------- Compra: Releasit (contra reembolso) / demo / carrito ---------- */
  OX.buy = function (s, btn) {
    var mode = cfg.buyMode;
    if (mode === 'demo') return OX.demoCheckout(s);
    if (mode === 'releasit') return OX.releasitCheckout(s, btn);
    return OX.cartCheckout(s, btn, false);
  };

  function cartAdd(items) {
    var url = cfg.cartAddUrl || ((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }

  // Releasit COD Form no tiene una función pública para abrirse: dibuja su propio
  // botón (#rsi_buy_now_button) dentro del formulario de producto y lee de ahí la
  // variante y la cantidad. Nuestros botones sincronizan el formulario y lo pulsan.
  OX.findReleasitButton = function () {
    return document.querySelector('#rsi_buy_now_button, [id^="rsi_buy_now_button"], button._rsi-buy-now-button');
  };

  OX.releasitCheckout = function (s, btn) {
    var addonItems = s.addons
      .filter(function (a) { return a.dataset.variant; })
      .map(function (a) { return { id: Number(a.dataset.variant), quantity: 1 }; });
    var done = false;
    function openForm() {
      var rsi = OX.findReleasitButton();
      if (!rsi) return false;
      done = true;
      if (btn) btn.removeAttribute('aria-busy');
      rsi.click();
      return true;
    }
    function proceed() {
      if (openForm()) return;
      // Releasit carga en diferido: lo esperamos unos segundos antes del plan B
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (openForm()) { clearInterval(timer); return; }
        if (tries > 20) {
          clearInterval(timer);
          if (!done) OX.cartCheckout(s, btn, addonItems.length > 0);
        }
      }, 200);
    }
    if (btn) btn.setAttribute('aria-busy', 'true');
    // Los complementos van al carrito antes; Releasit (modo «producto actual + carrito») los incluye en el pedido
    if (addonItems.length) cartAdd(addonItems).then(proceed, proceed);
    else proceed();
  };

  // Plan B sin la app: añade al carrito de Shopify y abre el carrito.
  OX.cartCheckout = function (s, btn, addonsAlreadyAdded) {
    var items = [];
    if (s.pack && s.pack.dataset.variant) {
      items.push({ id: Number(s.pack.dataset.variant), quantity: Number(s.pack.dataset.qty || 1) });
    } else {
      var form = $('[data-ox-product-form]');
      var idInput = form && $('input[name="id"]', form);
      if (idInput) items.push({ id: Number(idInput.value), quantity: 1 });
    }
    if (!addonsAlreadyAdded) {
      s.addons.forEach(function (a) { if (a.dataset.variant) items.push({ id: Number(a.dataset.variant), quantity: 1 }); });
    }
    var cartUrl = cfg.cartUrl || '/cart';
    if (!items.length) { window.location.href = cartUrl; return; }
    if (btn) btn.setAttribute('aria-busy', 'true');
    cartAdd(items).then(function () { window.location.href = cartUrl; }, function () { window.location.href = cartUrl; });
  };

  // Solo prototipo: enseña cómo se verá el formulario contra reembolso.
  OX.demoCheckout = function (s) {
    var modal = $('[data-ox-modal]');
    if (!modal) return;
    var summary = $('[data-ox-modal-summary]', modal);
    if (summary) {
      var lines = [(s.pack ? s.pack.dataset.title : 'Traductor') + ' — ' + money(s.price)];
      s.addons.forEach(function (a) { lines.push(a.dataset.title + ' — ' + money(a.dataset.price)); });
      summary.innerHTML = lines.map(function (l) { return '<li>' + l + '</li>'; }).join('') +
        '<li><strong>Total a pagar al recibir: ' + money(s.total) + '</strong></li>';
    }
    modal.classList.add('is-open');
    var closeBtns = $$('[data-ox-modal-close]', modal);
    closeBtns.forEach(function (b) { b.onclick = function () { modal.classList.remove('is-open'); }; });
    modal.onclick = function (e) { if (e.target === modal) modal.classList.remove('is-open'); };
  };

  /* ---------- Fecha estimada de entrega (días laborables) ---------- */
  function initDelivery() {
    var els = $$('[data-ox-delivery]');
    if (!els.length) return;
    var days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    var months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    function addBusinessDays(date, n) {
      var d = new Date(date.getTime());
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      return d;
    }
    function fmt(d, withMonth) {
      return days[d.getDay()] + ' ' + d.getDate() + (withMonth ? ' de ' + months[d.getMonth()] : '');
    }
    els.forEach(function (el) {
      var min = Number(el.dataset.min || 1);
      var max = Number(el.dataset.max || 2);
      var cutoff = Number(el.dataset.cutoff || 14);
      var now = new Date();
      var start = new Date(now.getTime());
      // Después de la hora de corte o en fin de semana, el pedido sale el siguiente día laborable
      if (now.getHours() >= cutoff || now.getDay() === 0 || now.getDay() === 6) start = addBusinessDays(start, 1);
      var a = addBusinessDays(start, min);
      var b = addBusinessDays(start, max);
      var sameMonth = a.getMonth() === b.getMonth();
      var from = $('[data-ox-delivery-from]', el);
      var to = $('[data-ox-delivery-to]', el);
      if (from) from.textContent = fmt(a, !sameMonth);
      if (to) to.textContent = fmt(b, true);
    });
  }

  /* ---------- Carruseles ---------- */
  function initCarousels() {
    $$('[data-ox-carousel]').forEach(function (c) {
      var track = $('[data-ox-carousel-track]', c);
      if (!track || c.dataset.oxInit) return;
      c.dataset.oxInit = '1';
      function step() {
        var item = track.children[0];
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
        return item.getBoundingClientRect().width + gap;
      }
      var prev = $('[data-ox-carousel-prev]', c);
      var next = $('[data-ox-carousel-next]', c);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    });
  }

  /* ---------- Barra fija de compra ---------- */
  function initSticky() {
    var bar = $('[data-ox-sticky]');
    if (!bar) return;
    var targets = $$('[data-ox-sticky-hide]');
    var visible = {};
    function update() {
      var anyVisible = Object.keys(visible).some(function (k) { return visible[k]; });
      var show = bar.hasAttribute('data-ox-sticky-always') ? true : (window.scrollY > 300 && !anyVisible);
      bar.classList.toggle('is-visible', show);
      document.documentElement.style.setProperty('--ox-sticky-h', show ? bar.offsetHeight + 'px' : '0px');
    }
    if ('IntersectionObserver' in window && targets.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible[en.target.dataset.oxStickyKey] = en.isIntersecting; });
        update();
      });
      targets.forEach(function (t, i) { t.dataset.oxStickyKey = 'k' + i; io.observe(t); });
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- Volver arriba ---------- */
  function initTop() {
    var btn = $('[data-ox-top]');
    if (!btn) return;
    window.addEventListener('scroll', function () { btn.classList.toggle('is-visible', window.scrollY > 900); }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
  }

  /* ---------- Marquesina: duplica el contenido para que el bucle no tenga saltos ---------- */
  function initMarquee() {
    $$('[data-ox-marquee]').forEach(function (track) {
      if (track.dataset.oxCloned) return;
      var items = Array.prototype.slice.call(track.children);
      items.forEach(function (it) {
        var c = it.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      });
      track.dataset.oxCloned = '1';
    });
  }

  /* ---------- Precios con formato español (49,99 €) ---------- */
  function initMoney(root) {
    $$('[data-ox-money]', root).forEach(function (el) {
      if (el.children.length) return;
      el.textContent = money(el.getAttribute('data-ox-money'));
    });
  }

  /* ---------- Complementos recomendados fuera de la página de producto ---------- */
  function initRecoLinks() {
    if ($('[data-ox-buy-root]')) return; // en la página de producto los gestiona initBuyBox
    $$('[data-ox-reco]').forEach(function (b) {
      if (b.dataset.oxInit) return;
      b.dataset.oxInit = '1';
      b.addEventListener('click', function () { if (b.dataset.href) window.location.href = b.dataset.href; });
    });
  }

  function init() {
    document.documentElement.classList.remove('ox-no-js');
    initMoney();
    initRecoLinks();
    initMarquee();
    initReveal();
    initDrawer();
    $$('[data-ox-gallery]').forEach(initGallery);
    initBuyBox();
    initDelivery();
    initCarousels();
    initSticky();
    initTop();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor de temas de Shopify: re-inicializa al recargar una sección
  document.addEventListener('shopify:section:load', function (e) {
    initMoney(e.target); initMarquee(); initReveal(); $$('[data-ox-gallery]').forEach(initGallery);
    initDelivery(); initCarousels(); initDrawer(); initRecoLinks();
  });
})();
